module.exports = __webpack_public_path__ + "media/components/magazinespage/static/rectangle1-840592d1a5e6ea0d549cf4ac325e4458.svg";